import 'daterangepicker/daterangepicker';

export default {
    init() {
        const grid = document.querySelector('[data-resource-grid]');

        if (!grid) {
            return;
        }

        const cards     = Array.from(grid.querySelectorAll('[data-resource-card]'));
        const emptyState = grid.querySelector('[data-resource-empty]');
        const countEl   = document.querySelector('[data-resource-count]');

        function updateCount(count) {
            if (countEl) {
                countEl.textContent = count + (count === 1 ? ' resource' : ' resources');
            }
        }

        const form      = document.querySelector('[data-resource-filter]');
        const keyword   = document.querySelector('#keyword');
        const taxType   = document.querySelector('#tax_type');
        const sort      = document.querySelector('#sort');
        const dateInput = document.querySelector('#date');
        const dateStart = document.querySelector('#date-start');
        const dateEnd   = document.querySelector('#date-end');

        // Cache the searchable/sortable values once.
        cards.forEach(card => {
            const titleEl = card.querySelector('[data-resource-title]');
            card.dataset.titleText = (titleEl ? titleEl.textContent : '').trim().toLowerCase();
        });

        /**
         * Toggle a card's visibility. Utilities are !important, so a class or
         * the `hidden` attribute won't win against `flex` — force it inline.
         */
        function setVisible(card, visible) {
            if (visible) {
                card.style.removeProperty('display');
            } else {
                card.style.setProperty('display', 'none', 'important');
            }
        }

        function applyFilters() {
            const kw    = (keyword && keyword.value ? keyword.value : '').trim().toLowerCase();
            const type  = taxType && taxType.value ? taxType.value : '';
            const start = dateStart && dateStart.value ? dateStart.value : ''; // Ymd
            const end   = dateEnd && dateEnd.value ? dateEnd.value : '';       // Ymd

            let visibleCount = 0;

            cards.forEach(card => {
                let visible = true;

                if (kw && card.dataset.titleText.indexOf(kw) === -1) {
                    visible = false;
                }

                if (type && card.dataset.type !== type) {
                    visible = false;
                }

                if (start && end) {
                    const cardDate = card.dataset.date || '';
                    if (!cardDate || cardDate < start || cardDate > end) {
                        visible = false;
                    }
                }

                setVisible(card, visible);

                if (visible) {
                    visibleCount++;
                }
            });

            if (emptyState) {
                emptyState.classList.toggle('hidden', visibleCount !== 0);
            }

            updateCount(visibleCount);
        }

        function applySort() {
            const value = sort && sort.value ? sort.value : 'title-asc';

            const sorted = cards.slice().sort((a, b) => {
                switch (value) {
                    case 'title-desc':
                        return b.dataset.titleText.localeCompare(a.dataset.titleText);
                    case 'date-desc':
                        return (b.dataset.date || '').localeCompare(a.dataset.date || '');
                    case 'date-asc':
                        return (a.dataset.date || '').localeCompare(b.dataset.date || '');
                    case 'title-asc':
                    default:
                        return a.dataset.titleText.localeCompare(b.dataset.titleText);
                }
            });

            sorted.forEach(card => grid.appendChild(card));
        }

        // Keyword filters only on submit — Enter inside the field or a click on
        // the search icon (a type="submit" button). Selects still filter live.
        if (form) {
            form.addEventListener('submit', event => {
                event.preventDefault();
                applyFilters();
            });
        }

        if (taxType) {
            taxType.addEventListener('change', applyFilters);
        }

        if (sort) {
            sort.addEventListener('change', applySort);
        }

        // Date range — keep the daterangepicker UI, write Ymd into the hidden
        // inputs and re-filter on apply/clear.
        if (dateInput && window.jQuery) {
            const $date = window.jQuery(dateInput);

            $date.daterangepicker({
                autoUpdateInput: false,
                locale: {
                    cancelLabel: 'Clear',
                },
            });

            $date.on('apply.daterangepicker', function (event, picker) {
                window.jQuery(this).val(picker.startDate.format('MMMM D, YYYY') + ' - ' + picker.endDate.format('MMMM D, YYYY'));
                dateStart.value = picker.startDate.format('YYYYMMDD');
                dateEnd.value   = picker.endDate.format('YYYYMMDD');
                applyFilters();
            });

            $date.on('cancel.daterangepicker', function () {
                window.jQuery(this).val('');
                dateStart.value = '';
                dateEnd.value   = '';
                applyFilters();
            });
        }

        // Establish the initial order to match the Sort field's default value.
        applySort();
        updateCount(cards.length);
    },
    finalize() {

    },
};
